export const getProfileForm = state => state.form.profile.fields; // eslint-disable-line import/prefer-default-export
